import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import {
  Layout, Card, TextField, Button,  SkeletonBodyText, Modal,
  Toast, Checkbox, Link, ExceptionList, Thumbnail, EmptyState, Badge, Icon, Pagination, Popover, ActionList, InlineStack, BlockStack, Box,
  // Filters,
  // ChoiceList
} from "@shopify/polaris";
// import { connect } from "react-redux";
import {
  SearchMinor, EditMinor,DragDropMajor, ResourcesMajor,
  // ChevronRightMinor
  //  AlertMinor
} from '@shopify/polaris-icons';
import utils from '../../../utils/utils'
import LinkingAliExpressProductModal from './components/LinkingAliExpressProductModal';
// import countryArrayConfig from '../../../assets/CountryArray';
import AgreementModal from "./components/AgreementModal";
import ProductReplaceSourceBanner from "../Products/components/ProductReplaceSourceBanner";
import { reqGetShopifyNewProductList, reqPostSourcingGoodsRequestSave, reqShopifyNewStoreBatchSourcing, reqGetUserSubcribe ,reqGetUserPoints} from '../../../api';
import SourcingLimitModal from '../SubscriptionPaid/components/SourcingLimitModal';
import UpgradePlanSourcingRedeemModal from '../SubscriptionPaid/components/UpgradePlanSourcingRedeemModal';

import "./index.css";
import intl from '../../../i18n/intl'
import { store } from "../../../store";
import { changeBannerData } from "../../../slice";

class ShopifyProductClass extends Component {
  state = {
    searchProduct: '',  // 搜索产品 或者产品 ID
    searchButtonLoading: false,

    importStatusSelected: 0,

    isSearching: '0',
    sinceId: 0,
    page: 1,
    size: 10,
    hasPrevious: false,
    hasNext: true,
    sinceIds: [0], // 用于获取数据的产品id数组
    previousId: 0,
    nextId: 0,
    total: 0,

    //弹窗
    showToast: false,  //弹窗显示
    showToastText: '',  //弹窗文字
    showToastIserror: false, //弹窗是否错误

    loadingPage: false,

    productsData: [],
    // 显示当前页产品的数量
    ShowProductNumber: 0,

    // sourcing 请求报价弹窗
    quoteModalActive: false,
    askForQuoteLoading: false,
    sourcing_product_id: 0,
    sourcing_shopify_product_table_id: 0,
    productDetailLink: '',
    mainCountryCode: 'US',

    notMeetActive: false,
    notMeetErrorMsg: '',
    // 限制sourcing请求次数弹窗
    sourcingLimitModalShow: false,
    agreement: false,

    batchSourcingActive: false,
    batchSourcingLoading: false,
    batchSourcingIds: [],
    allSelected: false,
    selectCount: 0,
    allowSelectCount: 0,

    sourcingLimit: true, // sourcing是否达到限制
    sourcingDay: 3, // sourcing限制次数
    dayRemainingCount: 0, // 剩余sourcing次数
    bulkSourcing: false, // 是否开启批量勾选
    seoModalData:'',//seo集成
    selectProductStatus:[],
    toPage:'',//跳转页
    userPointsData:{
      available_points:0,
      total_points:0
    },
    userPointsRedeem:{
      open:false,
      id:0,
      isPoints:false
    }
  };

  getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  }

  //进入页面调用接口
  componentDidMount() {
    if (this.getQueryString('title') !== null) {
      this.setState({
        searchProduct: this.getQueryString('title'),
      }, () => {
        this.getProductList();
      })
    } else {
      this.getProductList();
    }
    this.getUserPoints();
  }
// 获取积分
getUserPoints = async ()=>{
  let res = await reqGetUserPoints()
  if (res.code === '200') {
    this.setState({
      userPointsData:res.data
    })
  }
}
  // 获取页面列表
  getProductList = async (isSearch = false) => {
    if (isSearch) {
      this.setState({
        isSearching: '1',
        hasPrevious: false,
        hasNext: false,
      });
    } else {
      this.setState({
        loadingPage: true,
        hasPrevious: false,
        hasNext: false,
      });
    }
    const params = {
      searchTitle: this.state.searchProduct,
      sinceId: this.state.sinceId,
      size: this.state.size,
      // count: this.state.total // 将总产品数传入
      count: 0 // 将总产品数传入
    };
    const response = await reqGetShopifyNewProductList(params);
    if (response.code === '200') {
      let res = await reqGetUserSubcribe();
      const getData = response.data;
      const productList = getData.result;
      const total = this.state.searchProduct !== '' ? productList.length : getData.count;
      // const total = getData.count;
      const sinceIds = this.state.sinceIds; // 获取数据的产品id数组
      if (response.data.is_agreement === 1) {
        this.setState({
          agreement: false
        })
      } else {
        this.setState({
          agreement: true
        })
      }
      let lastId = 0; // 当前获取数据的最后一个产品ID
      let allow_count = 0;
      if (productList.length > 0) {
        lastId = productList[productList.length - 1]['id'];
        if (sinceIds.indexOf(lastId) === -1) {
          sinceIds.push(lastId); // 将当前获取的最后一个产品ID存入sinceIds数组
          this.setState({
            sinceIds: sinceIds
          });
        }

        for (let i = 0; i < productList.length; i++) {
          if (productList[i].sourcing === 0) {
            allow_count++;
          }
        }
      }
      // 更新分页数据
      const maxPage = Math.ceil(total / this.state.size);

      var hasPrevious = false;
      var hasNext = false;
      //如果当前页面大于1 且 小于 总分页   上下都为开启
      if (this.state.page > 1 && this.state.page < maxPage) {
        hasPrevious = true
        hasNext = true
        //如果当前页面小于等于1 且 小于总分页 下关闭 上开启
      } else if (this.state.page <= 1 && this.state.page < maxPage) {
        hasPrevious = false
        hasNext = true
        //如果当前页面大于1 且 大于等于 总分页   下开启 上关闭
      } else if (this.state.page > 1 && this.state.page >= maxPage) {
        hasPrevious = true
        hasNext = false
        // 否则都关闭
      } else if (this.state.page <= 1 && this.state.page >= maxPage) {
        hasPrevious = false
        hasNext = false
      }
      let person = store.getState().languageReducer.subScriptData;
      //更新状态
      this.setState({
        loadingPage: false,
        productsData: productList,
        searchButtonLoading: false,
        hasPrevious,
        hasNext,
        total: total,
        previousId: this.state.sinceIds[this.state.page - 2] ? this.state.sinceIds[this.state.page - 2] : 0,
        nextId: lastId,
        ShowProductNumber: productList.length,
        isSearching: '0',
        codeStatus: getData.codeStatus,
        allowSelectCount: allow_count,
        bulkSourcing: person?.level > 0 ? true : false,
        sourcingLimit: res?.data?.limit?.sourcing + res?.data?.limit?.sourcing_job,
        sourcingDay: res?.data?.day?.sourcing_num,
        dayRemainingCount: Number(res?.data?.day?.sourcing_num - (res?.data?.limit?.sourcing + res?.data?.limit?.sourcing_job)),
        allSelected: false,
        selectCount: 0,
      });
    } else {
      this.toggleToast(response.msg);
      this.setState({
        loadingPage: false,
        productsData: [],
        isSearching: '0',
        allSelected: false,
        selectCount: 0,
        searchButtonLoading: false,
        ShowProductNumber:0
      });
    }
  }

  // 链接完成，更新父组件信息
  callBackFunction = (data) => {
    let recordKey = data.recordKey;
    let shopifyData = this.state.productsData;
    shopifyData[recordKey].sourcing = 1;  // 设置为已导入状态

    this.setState({
      productsData: shopifyData,
    });
  }


  //提示弹窗
  toggleToast = (showToastText, showToastIserror = false) => {
    this.setState(({ showToast }) => ({
      showToast: !showToast,
      showToastText: showToastText,
      showToastIserror: showToastIserror
    }));
  };
  handleChangeSearch = utils.debounce(()=>{
    this.getProductList(true);
  },500)
  handleChangeSearch2 = utils.debounce((value)=>{
    this.verifyLink(value)
  },500)
  // input change
  handleInputChange = async (value, id) => {
    this.setState({
      [id]: value,
      productDetailLinkError: '',
    }, () => {
        if (id === 'searchProduct') {
          if (this.state.searchProduct === '') {
            this.handleChangeSearch()
          }
        }

        if (id === 'productDetailLink') {
          this.handleChangeSearch2(value);
        }
    });
  }
  
  // 清除搜索框
  handleClearButtonClick = async (id) => {
    this.setState({
      [id]: '',
      page: 1,
      sinceId: 0,
    }, () => {
      this.handleChangeSearch()
    });
  }
  
  // 搜索
  handleSearchButtonClick = () => {
    this.setState({
      page: 1,
      sinceId: 0,
      searchButtonLoading:true
    }, () => {
      this.handleChangeSearch()
    });
  }

  // Linking速卖通产品弹窗
  handleLinkingProductModal = (productId, shopifyProductTableId, recordKey) => {
    if (productId === '') {
      return false;
    }
    let modalContent = (
      <LinkingAliExpressProductModal
        show={true}
        id={productId}
        sid={shopifyProductTableId}
        recordKey={recordKey}
        updateCallBackFun={this.callBackFunction}
      />
    );
    this.setState({
      linkProductModal: modalContent
    });
  }

  // More Actions 展开
  togglePopoverActive = (RecordKey) => {
    let _data = this.state.productsData;
    let status = _data[RecordKey].moreActionShow;
    _data[RecordKey].moreActionShow = (status === 1) ? 0 : 1;

    this.setState({
      productsData: _data
    });
  }

  // ask for quote 确认请求弹窗 shopify产品ID, shopify产品表ID
  handleAskForQuoteModal = (productId = 0, shopifyProductTableId = 0, link) => {
    if (this.state.sourcingLimit >= this.state.sourcingDay) {
      if (this.state.userPointsData.available_points >= 200) {
        this.setState({
          userPointsRedeem:{
            open:true,
            isPoints:true,
            id:[productId],
          },
          sourcing_product_id: productId,
          sourcing_shopify_product_table_id: shopifyProductTableId,
          productDetailLink: link !=='' ? link : '',
        })
        return;
      }else {
      this.handleSourcingLimitModal();
      return;
      }
     
    }
    this.setState({
      sourcing_product_id: productId,
      sourcing_shopify_product_table_id: shopifyProductTableId,
      productDetailLink: link !=='' ? link : '',
      quoteModalActive: !this.state.quoteModalActive
    })
  }

  // 确认请求
  handleUserSubmitQuote = async () => {
    if (this.state.sourcing_product_id !== 0) {
      this.setState({ askForQuoteLoading: true });
      const params = {
        shopify_product_id:this.state.sourcing_product_id,
        user_product_id:this.state.sourcing_shopify_product_table_id,
        link: this.state.productDetailLink,
        main_country: this.state.mainCountryCode,
        is_point:0
      }
      const response = await reqPostSourcingGoodsRequestSave(params)
      this.setState({ askForQuoteLoading: false, showToast: false });
      if (response.code === '200') {
        this.setState({
          dayRemainingCount: this.state.dayRemainingCount - 1
        }, () => {
          this.toggleToast('Sourcing initiated');
          this.handleAskForQuoteModal(0, 0, '');
          this.setState({
            sourcingLimit: this.state.sourcingLimit + 1
          })
          this.getProductList(true)
        })
      } else if (response.code === '505') {  // 不满足sourcing条件时，弹窗提示
        this.handleAskForQuoteModal(0, 0, '');
        // this.handleNotMeetSourcingTips(response.msg);
        store.dispatch(changeBannerData({bannerData:{
          show:true,
          desc:response.msg
        }}));
      } else {
        this.toggleToast('Product already sourced');
      }

    } else {
      this.toggleToast('Something wrong');
    }
  }

  // url校验
  verifyLink(link) {
    let errorMsg = '';
    if (link === '') {
      errorMsg = intl.get('Please enter a product link.')
    } else {
      let re = /(http|ftp|https):\/\/[\w\-_]+(.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/;
      if (re.test(link) === false) {
        errorMsg = intl.get('URL is invalid');
      }
    }
    if (errorMsg === '') {
      return true;
    }

    this.setState({ productDetailLinkError: errorMsg });
    return false;
  }

  // select change
  handleSelectChange = (field, value) => {
    this.setState({
      [field]: value
    });
  }

  // 不满足sourcing弹窗
  handleNotMeetSourcingTips = (msg = '') => {
    this.setState(({ notMeetActive }) => ({
      notMeetActive: !notMeetActive,
      notMeetErrorMsg: msg
    }));
  }

  // sourcing请求弹窗控制开关
  handleSourcingLimitModal = () => {
    this.setState(({ sourcingLimitModalShow }) => ({
      sourcingLimitModalShow: !sourcingLimitModalShow
    }))
  }

  // 打开聊天对话框
  openIntercom = () => {
    let sendPreMsg = 'Hello, I would like to get more sourcing times. Can you help me?';

    try {
      // 填充信息并激活对话弹窗
      // window.Intercom('showNewMessage', sendPreMsg);
      window.Willdesk.show();
      window.Willdesk.chat(sendPreMsg);
    } catch (error) {
      console.info(error);
    }
    this.handleSourcingLimitModal();
  }

  // 单个选择checkbox
  handleSingleCheckboxChange = (value, key) => {
    let { productsData, batchSourcingIds, selectCount } = this.state;
    let is_change = false;
    if (value) {
      if (productsData[key].sourcing === 0 || productsData[key].sourcing === 2) {
        is_change = true;
        selectCount++;
        
        batchSourcingIds.push(productsData[key].id);
      }
    } else {
      is_change = true;
      selectCount--;
      batchSourcingIds.splice(batchSourcingIds.indexOf(productsData[key].id), 1);
    }

    if (is_change) {
     
      // 批量sourcing限制 end
      productsData[key].selected = value ? 1 : 0;

      this.setState({
        allSelected: selectCount > 0 ? true : false,
        selectCount,
        batchSourcingIds,
      });
    }
  }

  // 批量选择全选checkbox productsData
  handleCheckboxSelectAllChange = (value) => {
    let { productsData } = this.state;
    
    if (productsData.length > 0) {
      if (!value) {
        for (let i = 0; i < productsData.length; i++) {
          productsData[i].selected = 0;
      }
        this.setState({
          allSelected:false,
          productsData,
          selectCount: 0,
          batchSourcingIds: [],
        });
        return
      }
      // 判断是否全选
      let select = [];
      for (let i = 0; i < productsData.length; i++) {
        if (productsData[i].selected) {
          select.push(productsData[i].selected);
        }
    }
    // 取消全选和全选
    let isChecked = productsData.filter(item => item.sourcing === 0 || item.sourcing === 2);
      if (value && isChecked.length  === select.length && select.length > 0) {
        for (let i = 0; i < productsData.length; i++) {
          if (productsData[i].sourcing === 0 || productsData[i].sourcing === 2) {
            productsData[i].selected = 0;
          }
      }
        this.setState({
          allSelected:false,
          productsData,
          selectCount: 0,
          batchSourcingIds: [],
        });
        return
      }
      let count = 0;
      let ids = [];

      for (let i = 0; i < productsData.length; i++) {
          if (productsData[i].sourcing === 0 || productsData[i].sourcing === 2) {
            count++;
            ids.push(productsData[i].id);
            productsData[i].selected = 1;
          }
      }

      this.setState({
        allSelected: count > 0 ? true : false,
        selectCount: count,
        batchSourcingIds: ids,
      });
    }
  }

  // 批量sourcing弹窗控制
  handleBatchSourcingActive = (bool) => {
    // 批量选择限制 start
    let { productsData, allSelected,  dayRemainingCount } = this.state;
    let canSelect = [];
    
    let idList = [];
    for (let i = 0; i < productsData.length; i++) {
      if ((productsData[i].sourcing === 0 || productsData[i].sourcing === 2) && productsData[i].selected === 1) {
        canSelect.push(productsData[i].selected)
        idList.push(productsData[i].id)
      }
    }
    if (allSelected) {
      if (dayRemainingCount  < canSelect.length) {
        if (dayRemainingCount <= 0) {
          if (this.state.sourcingLimit >= this.state.sourcingDay) {
            if (this.state.userPointsData.available_points >= (200 * canSelect.length)) {
              this.setState({
                userPointsRedeem:{
                  open:true,
                  isPoints:true,
                  id:idList,
                }
              })
            }else {
            this.handleSourcingLimitModal();
            }
            return
          }
        }else {
          this.setState({
            showToast: false
          }, () => {
            store.dispatch(changeBannerData({bannerData:{
              show:true,
              desc:intl.get(`Sorry, you have {{dayRemainingCount}} sourcing times left within today.`,dayRemainingCount)
            }}));
            // this.toggleToast(`Sorry, you have ${dayRemainingCount} sourcing times left within today.`, false);
          })
        }
        
      }else {
        this.setState({
          batchSourcingActive: bool
        });
      }
      return
    }
    // 批量选择限制 end
    this.setState({
      batchSourcingActive: bool
    });
  }

  // 批量sourcing请求
  handleBatchSourcingRequest = async () => {
    let { batchSourcingIds, productsData } = this.state;

    if (batchSourcingIds.length === 0) {
      this.toggleToast('No products selected');
      return;
    }

    const params = {
      shopify_product_ids: batchSourcingIds.join(','),
      is_point:0
    }

    this.setState({ batchSourcingLoading: true });
    const response = await reqShopifyNewStoreBatchSourcing(params)

    let paramrs = {};
    paramrs.batchSourcingLoading = false;
    
    if (response.code === '200') {
      paramrs.allSelected = false;
      paramrs.selectCount = 0;
      paramrs.batchSourcingIds = [];
      paramrs.batchSourcingActive = false;
      for (let i = 0; i < productsData.length; i++) {
        productsData[i].selected = 0;
      }
      this.setState(paramrs, () => {
        this.toggleToast('Sourcing initiated');
        this.getProductList(true)
      });
    } else {
      this.setState(paramrs, () => {
        // this.toggleToast(response.msg);
        store.dispatch(changeBannerData({bannerData:{
          show:true,
          desc:response.msg
        }}));
      });
    }
  }
   // 积分消耗
   handlePointsRedeem = async ()=>{
    if (this.state.sourcing_product_id !== 0) {
     
        this.setState({ askForQuoteLoading: true });
        const params = {
          shopify_product_id:this.state.sourcing_product_id,
          user_product_id:this.state.sourcing_shopify_product_table_id,
          link: this.state.productDetailLink,
          main_country: this.state.mainCountryCode,
          is_point:1
        }
        const response = await reqPostSourcingGoodsRequestSave(params)
        this.setState({ askForQuoteLoading: false, showToast: false });
        if (response.code === '200') {
          this.handlePointsRedeemLess(true)
          this.setState({
            dayRemainingCount: this.state.dayRemainingCount - 1
          }, () => {
            this.toggleToast('Sourcing initiated');
          
            this.setState({
              sourcingLimit: this.state.sourcingLimit + 1
            })
            this.getProductList(true)
          })
        } else if (response.code === '505') {  // 不满足sourcing条件时，弹窗提示
         
          // this.handleNotMeetSourcingTips(response.msg);
          store.dispatch(changeBannerData({bannerData:{
            show:true,
            desc:response.msg
          }}));
          this.getProductList(true)
        } else {
          store.dispatch(changeBannerData({bannerData:{
            show:true,
            desc:response.msg
          }}));
          this.getProductList(true)
        }
      return
    }
    let id = this.state.userPointsRedeem.id;
    const params = {
      shopify_product_ids: id.join(','),
      is_point:1
    }

    this.setState({ batchSourcingLoading: true });
    const response = await reqShopifyNewStoreBatchSourcing(params)
    if (response.code === '200') {
      this.handlePointsRedeemLess(true)
      this.toggleToast('Sourcing initiated');
      this.getProductList(true)
    }else {
      store.dispatch(changeBannerData({bannerData:{
        show:true,
        desc:response.msg
      }}));
    }
  }
  // 减积分操作
  handlePointsRedeemLess = (isPoints)=>{
    if (isPoints) {
      this.setState({
        userPointsRedeem:{
          open:false,
          isPoints:false,
          id:0,
          isDetail:false,
          is_new:0
        },
        userPointsData:{
          ...this.state.userPointsData,
          available_points:Number(this.state.userPointsData.available_points) - 200
        }
      })
    }
  }
  // SEO集成
  handleSeoAudit = async (data)=>{
   let person = store.getState().languageReducer.subScriptData;
    let params = {
      website:person.domain,
      data_id:data.id,
      action:'product'
    }
    try {
      await fetch(`https://api-admin.seoant.com/open-api/v1/coop-seo/jumpOnPage`,{
        method: 'post',
        headers:{'Content-Type': 'application/json'},
        body: JSON.stringify(params)
      })
        .then(response => response.json())
        .then(res => {
          if (res.code === 200) {
            if (res.data.status === 1) {
              window.open(res.data.jump_url,'_blank')
            }else {
              let seoModal = (
                <Modal
                // large
                  open={true}
                  onClose={()=>{
                    this.setState({seoModalData:''})
                  }}
                >
                    <div className="seo_ant_modal">
                   <div className="seo_ant_modal_title">{intl.get("SEO audit needs SEOAnt installation, deeply integrated with Dropshipman.")} <span></span></div>
                   <div className="seo_ant_modal_banner">
                     <img height={240} src="/seoExperts/seo_modal_banner.png" alt="dropshipman" />
                   </div>
                   <div className="seo_ant_modal_button">
                     <Button onClick={()=>{
                    this.setState({seoModalData:''})
                  }}>{intl.get("Cancel")}</Button>
                     <Button variant='primary' onClick={()=>{
                       window.open(res.data.jump_url ? res.data.jump_url : 'https://share.channelwill.com/app/116548bae341884wGT','_blank')
                     }}>{intl.get("Try It For Free Now")}</Button>
                   </div>
                   </div>
                </Modal>
              )
              this.setState({
                seoModalData:seoModal
              })
            }
          }else {
            this.toggleToast(res.msg)
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });

    } catch (err) {
      console.warn('Error:', err)
    }
  }

  clearStatus = (type) => {
    if (type === "selectProductStatus") {
     this.setState({
       selectProductStatus: [],
     })
    }else {
      this.setState({
        selectProductStatus: [],
      })
    }
    // eslint-disable-next-line
  }
  handleFiltersClearAll = () => {
    if (this.state.selectProductStatus.length > 0) {
      this.clearStatus("selectProductStatus")
    }
  };
  render() {

    const toastMarkup = this.state.showToast ? <Toast content={this.state.showToastText} onDismiss={() => this.toggleToast('')} error={this.state.showToastIserror} /> : null;

    const {
      searchProduct, searchButtonLoading, isSearching, ShowProductNumber,  productsData, linkProductModal, quoteModalActive, askForQuoteLoading,
      // productDetailLink, productDetailLinkError,
      notMeetActive, notMeetErrorMsg, sourcingLimitModalShow, batchSourcingActive, batchSourcingLoading, allSelected, selectCount,seoModalData
      // agreement
    } = this.state;

    // [单个]ask for quote modal
    const quoteModal = (
      <Modal
        open={quoteModalActive}
        onClose={() => this.handleAskForQuoteModal(0, 0, '')}
        title={intl.get("Sourcing")}
        primaryAction={{
          content: intl.get('Done'),
          onAction: this.handleUserSubmitQuote,
          loading: askForQuoteLoading
        }}
        secondaryActions={[
          {
            content: intl.get('Cancel'),
            onAction: () => this.handleAskForQuoteModal(0, 0, ''),
          },
        ]}
      >
        <Modal.Section>
           
            {intl.get("Are you sure to source the product? Once we complete processing your request, the supplier of the product will be changed to Dropshipman.")}
           
        </Modal.Section>
      </Modal>
    );

    // [批量] 产品sourcing
    const batchQuoteModal = (
      <Modal
        open={batchSourcingActive}
        onClose={() => this.handleBatchSourcingActive(false)}
        title="Bulk Sourcing"
        primaryAction={{
          content: 'Done',
          onAction: this.handleBatchSourcingRequest,
          loading: batchSourcingLoading
        }}
        secondaryActions={[
          {
            content: 'Cancel',
            onAction: () => this.handleBatchSourcingActive(false),
          },
        ]}
      >
        <Modal.Section>
        {intl.get("Are you sure to source these products in bulk? After we complete your request, the supplier of these products will change to Dropshipman.")}
        </Modal.Section>
      </Modal>
    );

    // 不满足sourcing请求弹窗提示
    const NotMeetSourcingTips = (
      <Modal
        open={notMeetActive}
        onClose={this.handleNotMeetSourcingTips}
        title={intl.get("Sourcing tips")}
        secondaryActions={[
          {
            content: intl.get('Get it'),
            onAction: this.handleNotMeetSourcingTips,
          },
        ]}
      >
        <Modal.Section>
           
            <div>
              {notMeetErrorMsg}
            </div>
            <div>
              {'Learn more, please see '}<Link onClick={() => {
              utils.routeListen('/admin/wallet')
              utils.routeJump(this,'/admin/wallet')
              }} >{intl.get("Pre-Pay and Go plan")}</Link>
            </div>
           
        </Modal.Section>
      </Modal>
    );

    // 店铺版本为trial用户(201)的限制提示 或 非trail用户（202）
    // const sourcingLimitTips = (
    //   <Modal
    //     open={sourcingLimitModalShow}
    //     onClose={this.handleSourcingLimitModal}
    //     title={<div className='modalHasIcon'>
    //       <Icon source={AlertMinor} color="critical" />
    //       <span>{intl.get('Reach the sourcing limit')}</span>
    //     </div>}
    //     primaryAction={
    //       {
    //         content: intl.get("ok"),
    //         onAction: this.handleSourcingLimitModal,
    //       }
    //     }
    //   >
    //     <Modal.Section>
    //       <p style={{ fontSize: 15 }}>{intl.get("Sorry, you have reached the daily sourcing limit of {{count}} times.", this.state.sourcingDay)}</p>
    //     </Modal.Section>
    //   </Modal>
    // )

    // Tab选项
    // const statusTabs = [
    //   {
    //     id: 'all-of-product',
    //     content: intl.get("All") + ' (' + this.state.total + ')',
    //     accessibilityLabel: intl.get("All"),
    //     panelID: 'all-of-product',
    //   }
    // ];

    // 加载前页面
    const initSkeletonPage = <div>
       <Layout>
        <Layout.Section>
        <Card>
        <BlockStack gap={400}>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        <SkeletonBodyText lines={3}/>
        </BlockStack>
        </Card>
      </Layout.Section>
        </Layout>
    </div>
    // 批量选择
    let headings = '';
    if (this.state.bulkSourcing) {
      if (ShowProductNumber > 0 && selectCount > 0) {
        headings = (
          <div className="headings_div__1" style={{paddingTop:16}}>
            <div className="headings_div__2">
              <div className="Polaris-ButtonGroup Polaris-ButtonGroup--segmented" data-buttongroup-segmented="true">

                <div className="Polaris-ButtonGroup__Item">
                  <div className="Polaris-CheckableButton Polaris-CheckableButton__CheckableButton--selectMode Polaris-CheckableButton__CheckableButton--selected">
                    <div className="headings_div__3">
                      <Checkbox
                        label=''
                        labelHidden
                        checked={
                          allSelected ?
                            (selectCount === this.state.total || selectCount === this.state.size) ? true : 'indeterminate' :
                            false
                        }
                        onChange={this.handleCheckboxSelectAllChange}
                      />
                    </div>
                    <span className="Polaris-CheckableButton__Label">
                      {selectCount + " selected"}
                    </span>
                  </div>
                </div>

                <div className="Polaris-ButtonGroup__Item">
                  <div>
                    <Button variant="primary" onClick={() => this.handleBatchSourcingActive(true)}>
                      {intl.get("Bulk sourcing")}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )

      } else {
        headings = (
          <div className="headings_div__1" style={{paddingTop:16}}>
            <div className="headings_div__2">
              <div className="Polaris-ButtonGroup Polaris-ButtonGroup--segmented" data-buttongroup-segmented="true">
                <div className="Polaris-ButtonGroup__Item">
                  <div className="Polaris-CheckableButton Polaris-CheckableButton__CheckableButton--selectMode Polaris-CheckableButton__CheckableButton--selected">
                    <div className="headings_div__3">
                      <Checkbox
                        label=''
                        labelHidden
                        checked={allSelected}
                        onChange={this.handleCheckboxSelectAllChange}
                      />
                    </div>
                    <span className="Polaris-CheckableButton__Label">
                      {intl.get("Select all")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
    }

    // 空数据页面
    const EmptyProductList = (ShowProductNumber === 0) ? <div className="emptyWithImg" style={{minHeight:"650px",display:"flex",justifyContent:"center",alignItems:"center"}}>
      <EmptyState
        heading={intl.get("No product found")}
        image="/empty.svg"
      >
        <p>{intl.get("Please add product to store")}</p>
      </EmptyState>
    </div> : '';

    // 产品列表遍历
    const productListHtml = productsData.map((item, key) => {
      let showImageUrl = '/default_image.png';
      if (item.imageUrl !== '') {
        showImageUrl = item.imageUrl;
      }
      let rowHtml = <section className={"Product__Status_Pushed"} key={key}>
        <div className="">
          <Card>
            {/* 替换产品提示 */}
            <ProductReplaceSourceBanner show={item.autoMatch ? true : false} id={item.user_product_id} />

            <InlineStack align="space-between">
                <InlineStack blockAlign="center" align="start">
                  <div className="Checkbox">
                    <Checkbox
                      label=''
                      labelHidden
                      checked={item.selected}
                      onChange={(val) => this.handleSingleCheckboxChange(val, key)}
                      disabled={!this.state.bulkSourcing || item.sourcing === 1 }
                    />
                  </div>
                  <div className="Product_Img">
                    <Thumbnail
                      source={showImageUrl}
                      alt="product"
                    />
                  </div>
                  <div className="Product_Title">
                    <span>
                      {item.title}
                    </span>
                  </div>
                  {/* <div className="Product_Cost_Price" key={key}> */}
                    {/* <div className="Cost_Price_Text">{'Cost: -- --'}</div>
                    <div className="Price_Text">{'Price: -- --'}</div> */}
                  {/* </div> */}
                </InlineStack>
                <InlineStack blockAlign="center" align="start">
                  <div className="Product_Status_Badge">
                    <Badge tone={(item.productStatus === 0) ? "" : "info"}>{(item.productStatus === 0) ? intl.get("Hide") : intl.get("Active")}</Badge>
                  </div>
                  <div className="Product_Status_Badge">
                    <Badge tone={(item.sourcing === 0) ? "" : "warning"}>
                      {(item.sourcing === 1) ? intl.get("Pending") :(item.sourcing === 2) ? intl.get("Listed") : intl.get("Not sourced")}
                      </Badge>
                  </div>
                  </InlineStack>
              <InlineStack blockAlign="center">
                <div className="Product_Action Button Responsive_Button">
                <Button disabled={item.sourcing === 1} icon={ResourcesMajor} variant="plain"  onClick={() => this.handleAskForQuoteModal(item.id, item.user_product_id, item.link)}>
                {item.sourcing === 2 ? intl.get("Re-sourcing") : intl.get("Sourcing")}
              </Button>
                </div>
                <div className="Product_Action Button">
                  <Popover
                    active={(item.moreActionShow === 1) ? true : false}
                    activator={
                      <div className="Prodcut_More_Action">
                        <Button
                          disclosure={'down'}
                          onClick={this.togglePopoverActive.bind(this, key, true)}
                        >
                          {intl.get("More actions")}
                        </Button>
                      </div>
                    }
                    onClose={this.togglePopoverActive.bind(this, key, false)}
                  >
                    <ActionList
                      items={[
                        {
                          content:
                            <ExceptionList
                              items={[
                                {
                                  icon: EditMinor,
                                  description: intl.get('Edit on Shopify'),
                                },
                              ]}
                            />,
                          url: item.editOnShopify,
                          external: true
                        },
                        {
                          content:
                            <ExceptionList
                              items={[
                                {
                                  icon: DragDropMajor,
                                  description: intl.get("Seo Audit"),
                                },
                              ]}
                            />,
                          onAction: () => this.handleSeoAudit(item),
                        }
                      ]}
                    />
                  </Popover>
                </div>
              </InlineStack>
            </InlineStack>

          </Card>
        </div>
      </section>
      return rowHtml;
    });

    // 页码显示
    var footerContentMsg = '';
    if (ShowProductNumber !== 0) {
      const startNum = (((this.state.page - 1) * this.state.size) + 1);
      const endNum = (this.state.page * this.state.size > this.state.total) ? this.state.total : this.state.page * this.state.size;
      footerContentMsg = <div>{intl.get("Showing {{startNum}} - {{endNum}} of {{total}} results", startNum, endNum, this.state.total)}</div>;
    }
    const appliedFilters = [];
  if (!isEmpty(this.state.selectProductStatus)) {
    const key = "selectProductStatus";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, this.state.selectProductStatus),
      onRemove: () => this.clearStatus("selectProductStatus"),
    });
  }
   

    // 分页按钮
    const PaginationSettings = this.state.loadingPage ? '' : (
      (ShowProductNumber !== 0) ?
        <div className="Polaris-New-Pagination">
          <Pagination
            label={footerContentMsg}
            hasPrevious={this.state.hasPrevious}
            onPrevious={() => {
              this.setState(({
                page: Number(this.state.page) - 1,
                sinceId: this.state.previousId,
                batchSourcingIds: [],
                toPage:''
              }), () => {
                this.getProductList(true);
              });
            }}
            hasNext={this.state.hasNext}
            onNext={() => {
              this.setState(({
                page: Number(this.state.page) + 1,
                sinceId: this.state.nextId,
                batchSourcingIds: [],
                toPage:''
              }), () => {
                this.getProductList(true);
              });
            }}
          />
          {/* <div>
          <input
            className="Page_input"
            type="text"
            value={this.state.toPage}
            maxLength={"8"}
            onChange={(e) => {
              if (Number.isInteger(Number(e.target.value))) {
                if ((Number(e.target.value) > Math.ceil(this.state.total / 10) || Number(e.target.value) <= 0) && e.target.value !== '') {
                  this.setState({
                    toPage: 1,
                  });
                }else{
                this.setState({
                  toPage: e.target.value,
                });
              }
              }
            }}
          />
          <span
            className="Page_Jump"
            onClick={() => {
              let pageCount = Math.ceil(this.state.total / 10)
              if (pageCount === 1) return false;
              let page = 1;
              if (this.state.toPage <= pageCount) {
                page = this.state.toPage;
              }
              if (
                pageCount > 1 &&
                this.state.toPage <= pageCount
              ) {
                page = this.state.toPage;
              }
              if (page === '') {
                return
              }

              this.setState(
                {
                  page: page,
                },
                () => {
                  this.getProductList(true);
                }
              );
            }}
          >
            Go to
          </span>
        </div> */}
        </div> : '')

    // 最终页面
    const pageContent = this.state.loadingPage ? initSkeletonPage : <section id="shopify_product">
    
          <Box className="content_list_tab">
          {/* <Tabs tabs={statusTabs} selected={importStatusSelected}>
            </Tabs> */}
            <section style={{padding:'16px 16px 0'}}>
            <TextField
                  id="searchProduct"
                  value={searchProduct}
                  onChange={this.handleInputChange}
                  placeholder={intl.get("Filter products")}
                  prefix={<Icon source={SearchMinor} />}
                  clearButton
                  onClearButtonClick={this.handleClearButtonClick}
                  connectedRight={
                    <Button
                      variant="primary"
                      size="medium"
                      onClick={this.handleSearchButtonClick}
                      loading={searchButtonLoading}
                      disabled={searchProduct === ''}
                    >
                      {intl.get("Search Products")}
                    </Button>
                  }
                />
                {/* <Filters
                  hideQueryField
                  filters={[
                    {
                      key: "selectProductStatus",
                      label: intl.get("Product status"),
                      filter: (
                        <ChoiceList
                          title={intl.get("Product status")}
                          titleHidden
                          choices={[
                              { label: intl.get("Not Listed"), value: "Not imported" },
                              {label: intl.get("Listed"), value: "Imported" }
                          ]}
                          selected={this.state.selectProductStatus || []}
                          onChange={(val) => this.setState({selectProductStatus: val})}
                        />
                      ),
                      shortcut: true,
                      hideClearButton: true,
                    },
                  ]}
                  appliedFilters={appliedFilters}
                  onClearAll={this.handleFiltersClearAll}
                /> */}
                {(ShowProductNumber > 0 && !this.state.loadingPage) && headings}

                {/* 数据为空显示 */}
                <div style={{ position: 'relative' }}>

                  {EmptyProductList}

                  <div className="Product__Loading" style={{ display: (isSearching === '1' && ShowProductNumber === 0) ? 'block' : 'none' }}>
                    <div className="Product__Loading_Image">
                      <img style={{ width: '32px', height: '32px', verticalAlign: 'middle' }} src='/loading.gif' alt="loading" />
                    </div>
                  </div>
                </div>
                </section>
          </Box>
          {/* 产品列表输出 */}
          <div style={{ position: 'relative' }}>

            {productListHtml}

            <div className="Product__Loading" style={{ display: (isSearching === '1' && ShowProductNumber > 0) ? 'block' : 'none' }}>
              <div className="Product__Loading_Image">
                <img style={{ width: '32px', height: '32px', verticalAlign: 'middle' }} src='/loading.gif' alt="loading" />
              </div>
            </div>
          </div>
          {PaginationSettings}
    </section>


    return (
      <div>
          {pageContent}
          {/* shopify产品与速卖通产品关系对应弹窗 */}
          {linkProductModal}
          {/* 寻求报价弹窗 */}
          {quoteModal}
          {/* 批量sourcing弹窗 */}
          {batchQuoteModal}
          {/* 不满足sourcing提示弹窗 */}
          {NotMeetSourcingTips}
          {/* sourcing 用户限制*/}
          {/* {sourcingLimitTips} */}
          <SourcingLimitModal num={this.state.sourcingDay} sourcingOpen={sourcingLimitModalShow} setSourcingOpen={()=>this.setState({sourcingLimitModalShow:false})}/>
          <UpgradePlanSourcingRedeemModal 
        num={this.state.sourcingDay}
        upgradeOpen={this.state.userPointsRedeem.open}
        pointsData={this.state.userPointsData}
        handlePointsRedeem={()=>this.handlePointsRedeem()}
        setUpgradeOpen={()=>this.setState({
          userPointsRedeem:{
            open:false,
            id:0,
            isDetail:false,
            is_new:0,
            isPoints:false
            }})}/>
         {/* seo集成弹窗  */}
          {seoModalData}
          {toastMarkup}
          {/* 协议确认弹窗 */}
          {/* <AgreementModal agreement={agreement} /> */}
          <AgreementModal agreement={false} />
      </div>
    );
  }
}
function disambiguateLabel(key, value) {
  if (value && value[0].indexOf('Not imported') !== -1) {
    value = ['Not Listed']
  }
  if (value && value[0].indexOf('Imported') !== -1) {
    value = ['Listed']
  }
  switch (key) {
    case "selectProductStatus":
      return value.map((val) => val);
    default:
      return value;
  }
}
function isEmpty(value) {
  if (Array.isArray(value)) {
    return value.length === 0;
  } else {
    return value === "" || value == null;
  }
}
// const mapStateToProps = state => {
//   return {
//     subScriptData: state.languageReducer.subScriptData
//   }
// }
export default withRouter(ShopifyProductClass);